import { Box, Skeleton } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    card: {
        height: "200px",
    },
}))

export const SkeletonCard = () => {
    const { classes } = useStyles()
    return (
        <Box>
            <Skeleton variant="rectangular" className={classes.card} animation="wave" />
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
            <Skeleton width="60%" animation="wave" />
        </Box>
    )
}
